import { __decorate } from "tslib";
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { EnumFormTypes } from '@blade-sxp/device-management/interfaces/form';
let PlatformCard = class PlatformCard extends Vue {
    formData;
    config;
    rules;
    labelPosition;
    refKey;
    configDeviceList;
    checkedAll = false;
    formTypes = EnumFormTypes;
    disabledChecked = [];
    optionalChecked = [];
    newOptionalChecked = [];
    disabledList = [];
    deviceSearch = '';
    editeIdx = '';
    changeDeviceList(val) {
        if (val) {
            this.disabledChecked = [];
            this.optionalChecked = [];
            this.newOptionalChecked = [];
            val.forEach((it) => {
                if (it.addFlag) {
                    this.disabledChecked.push(it);
                    this.disabledList.push(it.deviceCode);
                }
                else {
                    let obj = { isUpdate: false };
                    this.optionalChecked.push({ ...it, ...obj });
                    this.newOptionalChecked.push({ ...it, ...obj });
                }
            });
        }
    }
    hideEditeInput(idx) {
        this.newOptionalChecked[idx].isUpdate = false;
    }
    showEdite(idx) {
        this.editeIdx = String(idx);
    }
    updateDeviceName(idx) {
        this.newOptionalChecked[idx].isUpdate = !this.newOptionalChecked[idx].isUpdate;
    }
    changeDeviceSearch(val) {
        if (val === '') {
            this.newOptionalChecked = this.optionalChecked;
        }
        else {
            // 返回包含关键词的数据;
            this.newOptionalChecked = this.optionalChecked.filter((item) => {
                let reg = new RegExp(val);
                return reg.test(item.deviceCode);
            });
        }
    }
    changePlatform(val) {
        this.$emit('changePlatform', val, true);
    }
    handleBtn(btnKey) {
        let isValid = true;
        this.$refs[this.refKey].validate((valid) => {
            isValid = valid;
        });
        this.$emit('handleBtn', {
            btnKey,
            formData: { ...this.formData },
            valid: isValid,
        });
    }
    validParams() {
        let isValid = false;
        this.$refs[this.refKey].validate((valid) => {
            isValid = valid;
        });
        return {
            valid: isValid,
            formData: { ...this.formData },
        };
    }
    deviceCheckAll(val) {
        let lists = [];
        if (val) {
            lists = this.newOptionalChecked.map((it) => {
                return it.deviceCode;
            });
        }
        else {
            lists = [];
        }
        this.$emit('deviceCheckAll', lists);
    }
    handleCheckedCitiesChange(value) {
        let checkedCount = value.length;
        this.checkedAll = checkedCount === this.newOptionalChecked.length;
    }
    handleChangeCascader() {
        const checkedCascaderInfo = this.$refs['cascaderRef'][0].getCheckedNodes()[0];
        this.$refs['cascaderRef'][0].dropDownVisible = false;
        this.$emit('cascaderChange', checkedCascaderInfo);
    }
};
__decorate([
    Prop()
], PlatformCard.prototype, "formData", void 0);
__decorate([
    Prop()
], PlatformCard.prototype, "config", void 0);
__decorate([
    Prop()
], PlatformCard.prototype, "rules", void 0);
__decorate([
    Prop({ type: String, default: 'top' })
], PlatformCard.prototype, "labelPosition", void 0);
__decorate([
    Prop()
], PlatformCard.prototype, "refKey", void 0);
__decorate([
    Prop()
], PlatformCard.prototype, "configDeviceList", void 0);
__decorate([
    Watch('configDeviceList', { deep: true })
], PlatformCard.prototype, "changeDeviceList", null);
PlatformCard = __decorate([
    Component({
        name: 'platformCardComponent',
    })
], PlatformCard);
export default PlatformCard;
